module.exports = __webpack_public_path__ + "media/smiles/dissapointed_1-62a02f2e.svg";